import React from "react";
import StylistOnBoardingForm from "./form";

function StylistOnBoarding(props) {
  return <StylistOnBoardingForm {...props}/>;
}

export default StylistOnBoarding;
